var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStep7(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 62.109,
    height: 62.109,
    viewBox: "0 0 62.109 62.109",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#efefef",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#efefef",
    stopOpacity: 0.102
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-12.863 -12.863)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(12.863 12.863)",
    stroke: "rgba(255,255,255,0.5)",
    strokeWidth: 2,
    fill: "url(#a)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 31.055,
    cy: 31.055,
    r: 31.055,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31.055,
    cy: 31.055,
    r: 30.055,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(29.219 19.489)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M868.357-370.784a2.24,2.24,0,0,1,2.279,2.282,2.241,2.241,0,0,1-2.285,2.281,2.249,2.249,0,0,1-2.3-2.269A2.23,2.23,0,0,1,868.357-370.784Zm1.614,2.267a1.643,1.643,0,0,0-1.651-1.639,1.621,1.621,0,0,0-1.587,1.659,1.581,1.581,0,0,0,1.644,1.622A1.6,1.6,0,0,0,869.972-368.517Z",
    transform: "translate(-830.961 398.064)",
    fill: "rgba(255,255,255,0.44)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M859.58-366.127a2.252,2.252,0,0,1,2.335-2.276,2.288,2.288,0,0,1,2.263,2.281,2.321,2.321,0,0,1-2.328,2.315A2.3,2.3,0,0,1,859.58-366.127Zm2.26,1.634a1.6,1.6,0,0,0,1.654-1.576,1.655,1.655,0,0,0-1.594-1.7,1.671,1.671,0,0,0-1.665,1.643A1.613,1.613,0,0,0,861.84-364.493Z",
    transform: "translate(-831.506 398.265)",
    fill: "rgba(255,255,255,0.44)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M847.39-384.241a4.03,4.03,0,0,0-1.293,1.8q-.55,1.613-1.124,3.218a1.409,1.409,0,0,1-1.949.9,1.4,1.4,0,0,1-.822-1.857c.429-1.254.867-2.5,1.3-3.758a5,5,0,0,1,1.266-1.961c1.206-1.169,2.335-2.411,3.469-3.647a1.851,1.851,0,0,1,1.911-.582,14.2,14.2,0,0,1,1.517.444,1.98,1.98,0,0,1,1.252,1.239,12.093,12.093,0,0,1,.593,2.974,3.416,3.416,0,0,1,.06.685c-.046.472.228.555.6.6,1.128.122,2.256.25,3.382.4a1.391,1.391,0,0,1,1.234,1.646,1.347,1.347,0,0,1-1.515,1.245c-1.091-.093-2.178-.226-3.265-.356-.213-.025-.335-.013-.342.243q-.026,1.076-.078,2.149a.418.418,0,0,0,.3.457c1.182.5,2.356,1.028,3.54,1.525a1.564,1.564,0,0,1,1.113,1.609c.026,1.192-.086,2.378-.171,3.565-.108,1.523-.284,3.042-.367,4.566a1.713,1.713,0,0,1-1.974,1.48,1.671,1.671,0,0,1-1.616-2.062c.14-1.548.236-3.1.35-4.65.028-.391.061-.781.074-1.172a.635.635,0,0,0-.39-.655c-1.019-.437-2.039-.873-3.065-1.294-.453-.186-.487-.163-.405.328a13.857,13.857,0,0,1-.57,5.922c-.469,1.764-.868,3.546-1.3,5.321a1.682,1.682,0,0,1-2.327,1.313,1.616,1.616,0,0,1-1.192-2.1c.559-2.327,1.123-4.653,1.673-6.982a8.262,8.262,0,0,0-.021-3.105,34.676,34.676,0,0,1-.408-4.479,24.551,24.551,0,0,1,.411-3.866C847.3-383.471,847.336-383.8,847.39-384.241Z",
    transform: "translate(-833.066 396.462)",
    fill: "rgba(255,255,255,0.44)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M836.512-373.854a2.42,2.42,0,0,1,.077-.267q.805-2.124,1.619-4.246c.041-.1.035-.272.19-.273.117,0,.151.142.2.231.78,1.361,1.531,2.739,2.417,4.038a.362.362,0,0,1,.026.381c-.118.27.011.394.258.479s.468.186.583-.166a.365.365,0,0,1,.284-.261,39.9,39.9,0,0,0,4.442-1.408c.111-.038.241-.134.343-.043s-.006.226-.045.332q-.555,1.482-1.119,2.959c-.168.443-.332.886-.511,1.325-.224.55-.51.679-1.049.474q-3.582-1.364-7.165-2.73A.727.727,0,0,1,836.512-373.854Z",
    transform: "translate(-833.425 397.386)",
    fill: "rgba(255,255,255,0.44)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M854.053-392.814a3.1,3.1,0,0,1-3.172,3.1,3.1,3.1,0,0,1-3.055-3.14,3.136,3.136,0,0,1,3.125-3.086A3.064,3.064,0,0,1,854.053-392.814Z",
    transform: "translate(-832.568 395.936)",
    fill: "rgba(255,255,255,0.44)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M841.406-378.5c-.235-.342-.19-.486.192-.618a2.812,2.812,0,0,1,3.132,1.227c.126.236.087.41-.175.588.69.263,1.33.511,1.972.751a.69.69,0,0,1,.5.577.385.385,0,0,1-.269.478c-1.477.488-2.934,1.035-4.441,1.428-.261.069-.439.088-.333-.283.069-.241-.147-.288-.307-.35s-.364-.212-.5.033c-.179.324-.3.156-.422-.033-.855-1.287-1.591-2.642-2.35-3.986a.356.356,0,0,1,.05-.478.6.6,0,0,1,.662-.181c.584.216,1.166.437,1.749.654.178.066.357.127.535.191l2.943,1.128a2.338,2.338,0,0,0-1.826-1.265A6.808,6.808,0,0,0,841.406-378.5Z",
    transform: "translate(-833.256 397.334)",
    fill: "rgba(255,255,255,0.44)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M833.683-356.6a2.255,2.255,0,0,1,2.3-2.274,2.323,2.323,0,0,1,2.3,2.351,2.3,2.3,0,0,1-2.305,2.245A2.254,2.254,0,0,1,833.683-356.6Z",
    transform: "translate(-833.683 399.071)",
    fill: "rgba(255,255,255,0.44)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M840.156-359.016a2.272,2.272,0,0,1,2.339-2.237,2.333,2.333,0,0,1,2.257,2.346,2.3,2.3,0,0,1-2.3,2.25A2.273,2.273,0,0,1,840.156-359.016Z",
    transform: "translate(-833.169 398.853)",
    fill: "rgba(255,255,255,0.44)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M855.544-361.494a2.271,2.271,0,0,1-2.289-2.369,2.288,2.288,0,0,1,2.315-2.227,2.315,2.315,0,0,1,2.281,2.358A2.29,2.29,0,0,1,855.544-361.494Z",
    transform: "translate(-832.127 398.46)",
    fill: "rgba(255,255,255,0.44)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M848.876-359.042a2.249,2.249,0,0,1-2.245-2.329,2.276,2.276,0,0,1,2.282-2.263,2.319,2.319,0,0,1,2.313,2.335A2.324,2.324,0,0,1,848.876-359.042Z",
    transform: "translate(-832.654 398.635)",
    fill: "rgba(255,255,255,0.44)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep7);
export default __webpack_public_path__ + "static/media/step7.89cdbb6a87cade23a84f9162467b8147.svg";
export { ForwardRef as ReactComponent };